import React, { Component } from 'react';

import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List';
import Paper from 'material-ui/Paper';

import { withRouter } from "react-router-dom";

class RelatedNav extends Component {
  render() {
    const { service } = this.props;
    return (
        <div>
          {
            service.doktori &&
              <div>
                <Typography variant="subheading" gutterBottom>
                  {service.doktori[1] === undefined ? 'Doktor' : 'Doktori'}
                </Typography>
                {
                  service.doktori.map(doktor => <Button className='relatedNavButton' key={doktor.id} onClick={(e) => {this.navigate(e, 'doktori', doktor.id)}}> { doktor.name } </Button>)
                }
              </div>
          }
          {
            service.usluge &&
              <div className='doctorServices'>
                <Typography variant="display1" gutterBottom>
                  Usluge
                </Typography>
                {
                  service.usluge.map((usluga, index) =>
                    {
                      return (
                        <Paper elevation={4} key={index} className='doctorServicesPaper'>
                          <List component='nav'>
                            <ListItem button={!!usluga.id} key={usluga.name} onClick={(e) => {this.navigate(e, 'usluge', usluga.id)}} className='doctorServiceHeader'>
                              <ListItemText primary={usluga.name} />
                              {usluga.id &&
                                <ListItemIcon>
                                  <svg fill="#0000008a" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M0 0h24v24H0z" fill="none"/>
                                      <path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"/>
                                  </svg>
                                </ListItemIcon>
                              }
                             </ListItem>
                            {usluga.podusluge !== undefined
                               && usluga.podusluge.map(podusluga =>
                              <ListItem button={!!podusluga.id} key={podusluga.name} onClick={(e) => {this.navigate(e, 'usluge', podusluga.id)}} className='podusluga'>
                                <ListItemText inset primary={podusluga.name} />
                                {podusluga.id &&
                                  <ListItemIcon>
                                    <svg fill="#0000008a" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0h24v24H0z" fill="none"/>
                                        <path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"/>
                                    </svg>
                                  </ListItemIcon>
                                }
                              </ListItem>
                            )}
                          </List>
                        </Paper>
                      )
                    }
                  )
                }
              </div>
          }
          {
            service.aparati &&
              <div>
                <Typography variant="subheading" gutterBottom>
                  {service.aparati[1] === undefined ? 'Aparat' : 'Aparati'}
                </Typography>
                {
                  service.aparati.map(aparat => <Button className='relatedNavButton' key={aparat.id} onClick={(e) => {this.navigate(e, 'aparati', aparat.id)}}> { aparat.name } </Button>)
                }
              </div>
          }
        </div>
    )
  }
  navigate = (e, category, id) => {
    if (id === undefined) {
      return
    }
    e.stopPropagation();
    this.props.history.push(`/${category}/${id}`);
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}

export default withRouter(RelatedNav);



// WEBPACK FOOTER //
// ./src/components/RelatedNav.js